(function () {
  const CARD_SELECTOR = '.product-card, .cc-card, .rc-item, .pdp-card, .pdp-rec-slider__card';
  const MEDIA_SELECTOR = '.product-card__image-wrap, .cc-card__img-wrap, .pdp-card__img-wrap, .pdp-rec-slider__img-wrap';
  const MOBILE_QUERY = '(max-width: 809px), (hover: none) and (pointer: coarse)';
  // Where the price lives per card type — used to anchor the mobile inline
  // quick-add row right below it. `.rc-item` (RangeCarousel) has no price
  // element at all, so it isn't listed here and always falls back to
  // "append at end of card".
  const PRICE_SELECTOR = '.product-card__price-wrap, .cc-card__price-wrap, .pdp-rec-slider__price-wrap, .pdp-card__price';

  let productMap = new Map();
  let observed = false;
  const pendingProducts = new Map();

  function normalizeHandle(href) {
    if (!href) return '';
    const match = String(href).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readProducts() {
    const map = new Map(productMap);
    document.querySelectorAll('script[data-quick-products]').forEach((script) => {
      if (script.dataset.quickProductsLoaded === 'true') return;
      try {
        const products = JSON.parse(script.textContent || '[]');
        if (Array.isArray(products)) {
          products.forEach((product) => {
            if (product && product.handle) map.set(product.handle, product);
          });
        }
        script.dataset.quickProductsLoaded = 'true';
      } catch (error) {
        console.warn('[Dissent] Invalid quick product data:', error);
      }
    });
    productMap = map;
  }

  function getProduct(card) {
    const link = getProductLink(card);
    const handle = normalizeHandle(link && link.getAttribute('href'));
    return handle ? productMap.get(handle) : null;
  }

  function getCardHandle(card) {
    const link = getProductLink(card);
    return normalizeHandle(link && link.getAttribute('href'));
  }

  function getProductLink(card) {
    if (card.matches('a[href*="/products/"]')) return card;
    return card.querySelector('a[href*="/products/"]');
  }

  function isMobileCardMode() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function navigateToProduct(card) {
    const link = getProductLink(card);
    if (link) window.location.href = link.href;
  }

  async function fetchProduct(handle) {
    if (!handle || productMap.has(handle)) return productMap.get(handle) || null;
    if (pendingProducts.has(handle)) return pendingProducts.get(handle);

    const request = (async () => {
      try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Product JSON unavailable');
      const raw = await response.json();
      const product = {
        id: raw.id,
        title: raw.title,
        handle: raw.handle || handle,
        url: `/products/${raw.handle || handle}`,
        price: raw.price,
        tags: raw.tags || [],
        options: normalizeOptions(raw.options),
        images: normalizeProductImages(raw),
        variants: Array.isArray(raw.variants) ? raw.variants.map((variant) => ({
          id: variant.id,
          title: variant.title,
          available: variant.available,
          price: variant.price,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
        })) : [],
      };
      productMap.set(product.handle, product);
      return product;
      } catch (error) {
        return null;
      } finally {
        pendingProducts.delete(handle);
      }
    })();

    pendingProducts.set(handle, request);
    return request;
  }

  function normalizeOptions(options) {
    if (!Array.isArray(options)) return [];
    return options.map((option) => {
      if (typeof option === 'string') return { name: option, values: [] };
      return {
        name: option && option.name ? option.name : '',
        values: Array.isArray(option && option.values) ? option.values.map(normalizeOptionValue).filter(Boolean) : [],
      };
    });
  }

  function normalizeOptionValue(value) {
    if (value == null) return '';
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    return String(value.name || value.value || value.title || '');
  }

  function normalizeProductImages(product) {
    if (Array.isArray(product.images)) {
      return product.images.map((image) => {
        if (typeof image === 'string') return { src: image, alt: product.title || '' };
        return { src: image && (image.src || image.url), alt: (image && image.alt) || product.title || '' };
      }).filter((image) => image.src);
    }
    return [];
  }

  function getMediaWrap(card) {
    if (card.classList.contains('rc-item')) return card;
    return card.querySelector(MEDIA_SELECTOR);
  }

  function getImages(product, card) {
    const images = Array.isArray(product.images)
      ? product.images.map((img) => ({
          src: typeof img === 'string' ? img : img && img.src,
          alt: (img && img.alt) || product.title || '',
        })).filter((img) => img.src)
      : [];
    if (images.length) return images;

    const existing = card.querySelector('img');
    return existing ? [{ src: existing.currentSrc || existing.src, alt: existing.alt || product.title || '' }] : [];
  }

  function hideOriginalMedia(wrap) {
    Array.from(wrap.children).forEach((child) => {
      if (
        child.classList.contains('product-card__wishlist') ||
        child.classList.contains('cc-card__wishlist') ||
        child.classList.contains('pdp-card__wishlist') ||
        child.classList.contains('cc-card__badge') ||
        child.classList.contains('pdp-card__badge') ||
        child.classList.contains('sale-badge') ||
        child.classList.contains('qpc-media') ||
        child.classList.contains('qpc-quick-add')
      ) {
        return;
      }
      child.classList.add('qpc-original-media');
    });
  }

  function buildMedia(card, wrap, product) {
    const images = getImages(product, card);
    if (!images.length || wrap.querySelector('.qpc-media')) return;

    hideOriginalMedia(wrap);

    const media = document.createElement('div');
    media.className = 'qpc-media';
    media.dataset.index = '0';

    const track = document.createElement('div');
    track.className = 'qpc-media__track';
    track.style.setProperty('--qpc-index', '0');
    media.dataset.mobileTaps = '0';

    images.forEach((image) => {
      const slide = document.createElement('button');
      slide.type = 'button';
      slide.className = 'qpc-media__slide';
      slide.setAttribute('aria-label', product.title || 'Ver producto');
      slide.addEventListener('click', (event) => {
        if (event.defaultPrevented) return;
        if (isMobileCardMode()) {
          event.preventDefault();
          event.stopPropagation();
          handleMobileMediaTap(card, media);
          return;
        }
        navigateToProduct(card);
      });

      const img = document.createElement('img');
      img.src = image.src;
      img.alt = image.alt || product.title || '';
      img.loading = 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);
    });

    media.appendChild(track);

    if (images.length > 1) {
      const prev = createMediaButton('prev', 'Imagen anterior', () => moveMedia(media, -1));
      const next = createMediaButton('next', 'Siguiente imagen', () => moveMedia(media, 1));
      media.append(prev, next);

      const dots = document.createElement('div');
      dots.className = 'qpc-media__dots';
      images.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `qpc-media__dot${index === 0 ? ' is-active' : ''}`;
        dot.setAttribute('aria-label', `Imagen ${index + 1}`);
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          setMediaIndex(media, index);
        });
        dots.appendChild(dot);
      });
      media.appendChild(dots);
    }

    wrap.insertBefore(media, wrap.firstChild);
  }

  function handleMobileMediaTap(card, media) {
    const slides = media.querySelectorAll('.qpc-media__slide');
    if (slides.length <= 1) {
      navigateToProduct(card);
      return;
    }

    const taps = Number(media.dataset.mobileTaps || 0) + 1;
    if (taps === 1) {
      media.dataset.mobileTaps = '1';
      return;
    }
    if (taps === 2) {
      setMediaIndex(media, Math.min(1, slides.length - 1));
      media.dataset.mobileTaps = '2';
      return;
    }

    navigateToProduct(card);
  }

  function createMediaButton(dir, label, onClick) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `qpc-media__nav qpc-media__nav--${dir}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = dir === 'prev' ? '&#8592;' : '&#8594;';
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    });
    return button;
  }

  function moveMedia(media, delta) {
    const slides = media.querySelectorAll('.qpc-media__slide');
    const current = Number(media.dataset.index || 0);
    const next = (current + delta + slides.length) % slides.length;
    setMediaIndex(media, next);
  }

  function setMediaIndex(media, index) {
    media.dataset.index = String(index);
    if (!isMobileCardMode()) media.dataset.mobileTaps = '0';
    const track = media.querySelector('.qpc-media__track');
    if (track) track.style.setProperty('--qpc-index', String(index));
    media.querySelectorAll('.qpc-media__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function detectIsEn() {
    const lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') === 0) return true;
    const locale = window.Shopify && window.Shopify.locale;
    return Boolean(locale && String(locale).toLowerCase().indexOf('en') === 0);
  }

  function findColorOptionIndex(product) {
    const options = Array.isArray(product.options) ? product.options : [];
    return options.findIndex((option) => /colou?r/i.test(option && option.name ? option.name : option));
  }

  function hasMultipleColors(product) {
    const idx = findColorOptionIndex(product);
    if (idx < 0) return false;
    const key = `option${idx + 1}`;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    // Count colours only among purchasable variants: a product whose other
    // colours are fully sold out should still quick-add the one that's left.
    // Fall back to every variant when nothing is available at all.
    const inStock = variants.filter((variant) => variant.available !== false);
    const pool = inStock.length ? inStock : variants;
    const values = new Set(pool.map((variant) => variant[key]).filter(Boolean));
    return values.size > 1;
  }

  function navigateToVariant(card, product, entry) {
    const link = getProductLink(card);
    const base = String(product.url || (link && link.getAttribute('href')) || '').split('?')[0];
    if (!base || !entry.variant) return;
    window.location.href = `${base}?variant=${entry.variant.id}`;
  }

  function insertInlinePanel(card, panel) {
    const priceEl = card.querySelector(PRICE_SELECTOR);
    if (!priceEl) {
      // Never append interactive buttons inside a card that is itself a link.
      if (card.tagName === 'A') return;
      card.appendChild(panel);
      return;
    }
    // Anchor the panel after the product link that wraps the price (e.g.
    // .pdp-rec-slider__link, .cc-card__link) so the size buttons are never
    // nested inside an <a>. Cards must be a wrapper element with the link
    // inside; a card that IS the link cannot host a quick-add panel.
    const nestedLink = priceEl.closest('a');
    if (nestedLink === card) return;
    // In the collection grid the price sits in a single-line flex row next to
    // the product name (.product-card__info, overflow hidden). Putting the
    // size row inside it squeezes the name to "Wh..." and clips the sizes, so
    // anchor after the whole row instead: name + price on one line, sizes on
    // their own line below, matching the home carousel.
    const infoRow = priceEl.closest('.product-card__info');
    const target = nestedLink && nestedLink !== card ? nestedLink : (infoRow || priceEl);
    target.parentNode.insertBefore(panel, target.nextSibling);
  }

  function findSizeOptionIndex(product) {
    const options = Array.isArray(product.options) ? product.options : [];
    const idx = options.findIndex((option) => /size|talla|tama(?:ñ|n)o/i.test(option && option.name ? option.name : option));
    return idx;
  }

  function getSizeEntries(product) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const availableVariants = variants.filter((variant) => variant && variant.available !== false);
    const optionIndex = findSizeOptionIndex(product);
    const optionKey = optionIndex >= 0 ? `option${optionIndex + 1}` : '';
    const option = optionIndex >= 0 && Array.isArray(product.options) ? product.options[optionIndex] : null;
    let optionValues = option && Array.isArray(option.values) ? option.values.map(normalizeOptionValue).filter(Boolean) : [];
    if (optionIndex >= 0 && !optionValues.length) {
      optionValues = Array.from(new Set(variants.map((variant) => variant[optionKey]).filter(Boolean)));
    }

    if (optionIndex < 0 || variants.length <= 1 || !optionValues.length) {
      const variant = availableVariants[0] || variants[0];
      return {
        hasSizePicker: false,
        entries: variant ? [{ label: 'Agregar', variant, available: variant.available !== false }] : [],
      };
    }

    const values = optionValues.length
      ? optionValues
      : Array.from(new Set(variants.map((variant) => variant[optionKey]).filter(Boolean)));

    return {
      hasSizePicker: true,
      entries: values.map((value) => {
        const matching = variants.filter((variant) => variant[optionKey] === value);
        const available = matching.find((variant) => variant.available !== false);
        return {
          label: value,
          variant: available || matching[0],
          available: Boolean(available),
        };
      }),
    };
  }

  function buildQuickAdd(card, wrap, product) {
    if (card.querySelector('.qpc-quick-add')) return;
    // .rc-item is the "shop the look" image strip: a fixed-height tile with
    // no price and no room for a size row. It keeps the media enhancements
    // (double-tap) but never gets a quick-add panel.
    if (card.matches('.rc-item')) return;

    const { hasSizePicker, entries } = getSizeEntries(product);
    if (!entries.length) return;

    const inline = isMobileCardMode();

    const panel = document.createElement('div');
    panel.className = inline ? 'qpc-quick-add qpc-quick-add--inline' : 'qpc-quick-add';

    const label = document.createElement('span');
    label.className = 'qpc-quick-add__label';
    label.textContent = hasSizePicker ? 'Quick add' : 'Quick add';
    panel.appendChild(label);

    const sizes = document.createElement('div');
    sizes.className = 'qpc-quick-add__sizes';

    entries.forEach((entry) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `qpc-quick-add__size${entry.available ? '' : ' is-disabled'}`;
      button.textContent = entry.label;
      button.disabled = !entry.available;
      button.setAttribute('aria-label', entry.available ? `Agregar ${product.title} talla ${entry.label}` : `${entry.label} no disponible`);
      if (!entry.available) button.setAttribute('aria-disabled', 'true');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!entry.available || !entry.variant) return;
        // Owner's rule (applies on mobile AND desktop): with more than one
        // color we can't know which color the shopper wants, so send them to
        // the PDP with this size preselected instead of guessing the color.
        if (hasMultipleColors(product)) {
          navigateToVariant(card, product, entry);
          return;
        }
        addVariant(entry.variant.id, panel, button);
      });
      sizes.appendChild(button);
    });

    panel.appendChild(sizes);

    if (inline) {
      insertInlinePanel(card, panel);
    } else {
      wrap.appendChild(panel);
    }
  }

  function showInlineError(panel, error, isEn) {
    const existing = panel.querySelector('.qpc-quick-add__error');
    if (existing) existing.remove();
    const message = (window.DissentCart && typeof window.DissentCart.atcErrorMessage === 'function')
      ? window.DissentCart.atcErrorMessage(error, isEn)
      : (isEn ? "Couldn't add to bag, try again" : 'No pudimos agregarlo, intenta de nuevo');
    const span = document.createElement('span');
    span.className = 'qpc-quick-add__error';
    span.setAttribute('role', 'alert');
    span.textContent = message;
    panel.appendChild(span);
    setTimeout(() => span.remove(), 4000);
  }

  async function addVariant(variantId, panel, button) {
    if (!variantId || panel.dataset.loading === 'true') return;
    panel.dataset.loading = 'true';
    panel.classList.remove('is-error', 'is-added');
    if (button) button.classList.add('is-adding');

    const isEn = detectIsEn();

    try {
      if (window.DissentCart && typeof window.DissentCart.addToCart === 'function') {
        // The shared helper already dispatches cart:updated — we only need
        // to open the drawer ourselves afterward.
        await window.DissentCart.addToCart(variantId, 1);
        document.dispatchEvent(new CustomEvent('cart:open'));
      } else {
        // Fallback for a script-load-order race where main.js (and its
        // window.DissentCart bridge) hasn't run yet.
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        if (!response.ok) throw new Error('Add to cart failed');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
      panel.classList.add('is-added');
      if (button) {
        button.classList.remove('is-adding');
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 1500);
      }
      setTimeout(() => panel.classList.remove('is-added'), 1400);
    } catch (error) {
      console.error('[Dissent] quick-add error:', error);
      panel.classList.add('is-error');
      if (button) button.classList.remove('is-adding');
      showInlineError(panel, error, isEn);
      setTimeout(() => panel.classList.remove('is-error'), 1800);
    } finally {
      panel.dataset.loading = 'false';
    }
  }

  async function enhanceCard(card) {
    if (card.dataset.quickEnhanced === 'true') return;
    const handle = getCardHandle(card);
    const product = getProduct(card) || await fetchProduct(handle);
    const wrap = product && getMediaWrap(card);
    if (!product || !wrap) return;

    card.dataset.quickEnhanced = 'true';
    wrap.classList.add('qpc-wrap');
    buildMedia(card, wrap, product);
    buildQuickAdd(card, wrap, product);
  }

  function enhanceAll() {
    readProducts();
    document.querySelectorAll(CARD_SELECTOR).forEach(enhanceCard);
  }

  function observe() {
    if (observed) return;
    observed = true;
    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(enhanceAll);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    enhanceAll();
    observe();
    setTimeout(enhanceAll, 250);
    setTimeout(enhanceAll, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
